import ObjectStatus from '../enums/static/ObjectStatus';
import {DynamicParametersType} from '../dynamicParameters/dynamicParameters.enums';
import {
  RemoteAiContentTextSpec,
  RemoteAiContentImageSpec,
  RemoteAiContentVideoSpec,
} from './aiContentProject.types';

export enum AiContentOutputStatus {
  NotStarted = 0,
  GeneratingPrompts = 1,
  PromptsGenerated = 2,
  GeneratingAssets = 3,
  AssetsGenerated = 4,
}

export interface RemoteAiContentOutputForAdSize {
  status: AiContentOutputStatus;
  fineTunedPrompt?: string | null;
  textSpec?: RemoteAiContentTextSpec | null;
  imageSpec?: RemoteAiContentImageSpec | null;
  videoSpec?: RemoteAiContentVideoSpec | null;
  value?: string | null;
  generationError?: string | null;
}

export interface RemoteAiContentIntermediateImage {
  assetId: number;
  imageSpec: RemoteAiContentImageSpec;
}

export interface RemoteAiContentOutputDeliverable {
  assetType: DynamicParametersType;
  prompt?: string | null;
  reasoning?: string | null;
  promptError?: string | null;
  byAdSize?: Record<string, RemoteAiContentOutputForAdSize> | null;
  intermediateImages?: RemoteAiContentIntermediateImage[] | null;
  activeIntermediateImageIndex?: number | null;
}

export interface RemoteAiContentItem {
  id: number;
  name: string;
  projectId: number;
  clientId: number;
  status: ObjectStatus;
  inputValues: Record<string, unknown>;
  outputDeliverables?: Record<string, RemoteAiContentOutputDeliverable> | null;
}

export interface CreateAiContentItemRequest {
  name: string;
  projectId: number;
  inputValues: Record<string, unknown>;
}

export interface CreateMultipleAiContentItemsRequest {
  items: CreateAiContentItemRequest[];
}

export interface UpdateAiContentItemRequest {
  name?: string | null;
  inputValues?: Record<string, unknown | null> | null;
  outputDeliverables?: Record<string, RemoteAiContentOutputDeliverable> | null;
}

export enum IntermediateGenerationMode {
  Full = 0,
  IntermediateOnly = 1,
  CropOnly = 2,
}

export interface GeneratePromptsRequest {
  itemIds: number[];
}

export interface GenerateAssetsRequest {
  itemIds: number[];
  adSizes?: string[] | null;
  deliverableKeys?: string[] | null;
  intermediateMode?: IntermediateGenerationMode | null;
  intermediateOutputCount?: number | null;
}

export interface UpdatePromptsRequest {
  itemIds: number[];
  adSizes: string[];
  updatePrompt: string;
}
